import {
  RouteScroller,
  measureRouteViewport,
} from "@client/components/utils/RouteScroller";
import { Link } from "wouter";
import { Skeleton } from "@sfc/ui";
import { ApplicationLoading } from "./ApplicationLoading";

// Kept apart from OpenApplications.tsx (the applicant-facing preview and its
// form-guide/apply stack) so the `/apply` route's own loading skeleton, and
// the app shell's sign-in screen, don't have to pull that heavier module in
// eagerly just to render a fallback.
export function ApplicationPreviewShell({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <RouteScroller data-application-preview-scroll ref={measureRouteViewport}>
      <main className="mx-auto w-full max-w-[1200px] space-y-8 px-6 py-8 md:px-10">
        <span hidden data-application-theme="green" />
        <Link
          href="/apply"
          className="inline-block label-md text-primary hover:underline underline-offset-4"
        >
          ← Funding Rounds
        </Link>
        {children}
      </main>
    </RouteScroller>
  );
}

export function ApplicationPreviewLoading() {
  return (
    <ApplicationPreviewShell>
      <ApplicationPreviewLoadingContent />
    </ApplicationPreviewShell>
  );
}

export function ApplicationPreviewLoadingContent() {
  return (
    <div className="space-y-6">
      <header className="flex flex-wrap items-start justify-between gap-6">
        <div className="w-full max-w-2xl space-y-3">
          <Skeleton
            className="h-9 w-3/4 motion-reduce:animate-none"
            aria-hidden="true"
          />
          <p className="body-lg text-muted-foreground">
            Browse the application questions before you apply.
          </p>
        </div>
      </header>
      <div className="grid items-start gap-8 lg:grid-cols-[14rem_minmax(0,1fr)]">
        <div className="space-y-3" aria-hidden="true">
          <Skeleton className="h-6 w-3/4 motion-reduce:animate-none" />
          <Skeleton className="h-6 w-2/3 motion-reduce:animate-none" />
        </div>
        <ApplicationLoading layout="questions" />
      </div>
    </div>
  );
}
